import { gql } from '@apollo/client'

export const FIELD_LINK_CREATE_MUTATION = gql`
  mutation FIELD_LINK_CREATE($input: FieldLinkInput!) {
    fieldLinkCreate(input: $input) {
      ok
    }
  }
`

export const FIELD_LINK_DELETE_MUTATION = gql`
  mutation FIELD_LINK_DELETE($input: [FieldLinkBunchDeleteInput!]!) {
    fieldLinkBunchDelete(input: $input) {
      ok
    }
  }
`

export const FIELD_LINK_UPDATE_MUTATION = gql`
  mutation FIELD_LINK_UPDATE($id: ID!, $input: FieldLinkInput!) {
    fieldLinkUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const FIELD_LINK_BUNCH_UPDATE_MUTATION = gql`
  mutation FIELD_LINK_BUNCH_UPDATE($input: [FieldLinkInput!]!) {
    fieldLinkBunchUpdate(input: $input) {
      ok
    }
  }
`

export const FIELD_GROUP_CREATE_MUTATION = gql`
  mutation FIELD_GROUP_CREATE($input: [FieldGroupInput!]!) {
    fieldGroupBunchCreate(input: $input) {
      data {
        id
      }
    }
  }
`

export const FIELD_GROUP_DELETE_MUTATION = gql`
  mutation FIELD_GROUP_DELETE($input: [FieldGroupBunchDeleteInput!]!) {
    fieldGroupBunchDelete(input: $input) {
      ok
    }
  }
`
